import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Gift, ArrowRight } from "lucide-react";

export default function LeadMagnetFunnel() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/analytics/lead-magnet").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const pct = (a, b) => (b ? `${Math.round((a / b) * 100)}%` : "—");
  const steps = [
    { k: "asked", label: "Asked for guide", v: d.asked },
    { k: "downloads", label: "Downloaded", v: d.downloads, sub: `${d.download_clicks} clicks` },
    { k: "enrolled", label: "In nurture", v: d.enrolled, sub: `${d.nurture_sent} emails · ${d.sms_sent} SMS` },
    { k: "replied", label: "Replied", v: d.nurture_replied, sub: `${d.nurture_opened} opens` },
    { k: "booked", label: "Calls booked", v: d.booked },
    { k: "won", label: "Deals won", v: d.won, sub: d.won_value ? `$${d.won_value.toLocaleString()}` : "" },
  ];
  return (
    <section className="border border-border rounded-md bg-card p-5" data-testid="lead-magnet-funnel">
      <div className="flex items-center justify-between gap-3 mb-4">
        <div>
          <div className="text-sm font-medium flex items-center gap-2"><Gift className="w-4 h-4 text-primary" />Lead magnet funnel{d.title ? <span className="text-muted-foreground font-normal">· {d.title}</span> : null}</div>
          <div className="text-xs text-muted-foreground">From "I want the guide" to closed deal — every step the widget + nurture drives.</div>
        </div>
        {!d.enabled && <Link to="/settings#widget" className="text-xs text-primary hover:underline" data-testid="lead-magnet-funnel-setup">Set up a lead magnet →</Link>}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-2">
        {steps.map((s, i) => (
          <div key={s.k} className="relative border border-border rounded-md p-3 bg-background/40" data-testid={`funnel-${s.k}`}>
            <div className="text-[10px] uppercase tracking-[0.1em] text-muted-foreground">{s.label}</div>
            <div className="display text-2xl font-semibold mono mt-1">{s.v}</div>
            <div className="text-[11px] text-muted-foreground h-4">{s.sub || (i > 0 ? pct(s.v, steps[i - 1].v) + " of prev" : "")}</div>
            {i < steps.length - 1 && <ArrowRight className="hidden md:block absolute -right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground/50" />}
          </div>
        ))}
      </div>
    </section>
  );
}
